import { gql } from '@apollo/client';

export const GENERATE_EOC_REPORT = gql`
  query GenerateEocReport($cId: ID!, $pId: ID!) {
    generateEocReport(cId: $cId, pId: $pId) {
      base64
      fileName
      mimeType
    }
  }
`;